import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HTMLTagsWithoutChildren } from "./helpers/elementGroups.js";
export function ImageUI({ id, selected, context, updateData, close, }) {
    async function onUpload(e) {
        try {
            const file = e.target.files?.[0];
            if (!file)
                return;
            else if (!file.type.startsWith("image/"))
                return console.error("Invalid file type. Please upload an image.");
            const uploadURL = await context.uploadImage?.(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                updateData(uploadURL || reader.result);
            };
            reader.readAsDataURL(file);
            close();
        }
        catch (e) {
            console.error("Failed to upload image.");
        }
    }
    return !selected ? null : (_jsxs("div", { className: "Launched__tag-imageUpload", children: [_jsx("label", { className: "Launched__button", htmlFor: `${id}-upload`, children: _jsxs("svg", { viewBox: "0 0 24 24", className: "Launched__icon", children: [_jsx("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }), _jsx("polyline", { points: "17 8 12 3 7 8" }), _jsx("line", { x1: "12", y1: "3", x2: "12", y2: "15" })] }) }), _jsx("input", { id: `${id}-upload`, type: "file", onChange: onUpload, accept: "image/*" })] }));
}
export const ImageRenderer = {
    component: (props) => {
        return _jsx(ImageUI, { ...props });
    },
    parentValidator: (el) => {
        const invalid = HTMLTagsWithoutChildren.includes(el.tagName);
        if (invalid)
            console.warn("Hint: If you're trying to attach an image tag to an IMG element, tag a wrapper element instead.");
        return !invalid;
    },
    getStaticProperties: (el) => {
        const image = el.querySelector("img");
        if (!image) {
            console.warn("An image tag must contain an IMG element as a child.");
            return "";
        }
        return image.src;
    },
    updateStaticProperties: ({ element, data }) => {
        const image = element.querySelector("img");
        if (!image) {
            console.warn("An image tag must contain an IMG element as a child.");
            return;
        }
        image.src = data;
    },
};
